export function getPluralCategoryRu(count) {
  const numeric = Number(count);
  if (!Number.isFinite(numeric)) return "other";

  const n = Math.abs(Math.trunc(numeric));
  const mod10 = n % 10;
  const mod100 = n % 100;

  if (mod10 === 1 && mod100 !== 11) return "one";
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "few";
  if (mod10 === 0 || (mod10 >= 5 && mod10 <= 9) || (mod100 >= 11 && mod100 <= 14)) return "many";

  return "other";
}

export function getPluralCategory(count, locale = "ro") {
  const numeric = Number(count);
  if (!Number.isFinite(numeric)) return "other";

  const normalizedLocale = String(locale || "ro").toLowerCase();
  if (normalizedLocale.startsWith("ru")) return getPluralCategoryRu(numeric);

  if (typeof Intl !== "undefined" && typeof Intl.PluralRules === "function") {
    try {
      return new Intl.PluralRules(locale).select(Math.abs(numeric));
    } catch {
      // Fall through to basic pluralization.
    }
  }

  return Math.abs(numeric) === 1 ? "one" : "other";
}

export function pluralize(count, forms, { locale } = {}) {
  const numeric = Number(count);
  const safeCount = Number.isFinite(numeric) ? numeric : 0;

  const normalizedForms = Array.isArray(forms)
    ? { one: forms[0], few: forms[1], many: forms[2], other: forms[2] ?? forms[1] ?? forms[0] }
    : (forms || {});

  const category = safeCount === 0 && normalizedForms.zero ? "zero" : getPluralCategory(safeCount, locale);
  const template =
    normalizedForms[category] ??
    normalizedForms.other ??
    normalizedForms.many ??
    normalizedForms.few ??
    normalizedForms.one ??
    "";

  return String(template).replace(/{{\s*count\s*}}/g, String(safeCount));
}
